import { render, staticRenderFns } from "./column-multi.vue?vue&type=template&id=56b92534"
import script from "./column-multi.vue?vue&type=script&lang=js"
export * from "./column-multi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports